var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',[_vm._v(_vm._s(_vm.car.id))])]),_c('div',{staticClass:"col-md-6"},[_c('p',[_vm._v(_vm._s(_vm.car.km)+" Km")])])])}
var staticRenderFns = []

export { render, staticRenderFns }